module.exports = __webpack_public_path__ + "static/media/howtobookbank.0871568d.svg";